import Confirm from 'components/shared/Modal/Confirm/Confirm';

const AccordionConfirmModals = ({
  confirmationModalVisible,
  onCloseConfirmation,
  onConfirmContinue,
  unconfirmationModalVisible,
  onCloseUnconfirmation,
  onUnconfirmContinue,
  isConfirming
}) => (
  <>
    <Confirm
      icon="info-circle-filled"
      iconColor="primary"
      variant="primary"
      isOpen={confirmationModalVisible}
      handleClose={onCloseConfirmation}
      title="Confirm Step?"
      message="Are you sure you want to confirm this step? This action will mark the step as confirmed."
      footerActions={{
        primary: {
          text: 'Confirm',
          onClick: onConfirmContinue,
          isLoading: isConfirming
        }
      }}
    />

    <Confirm
      icon="info-circle-filled"
      iconColor="warning"
      variant="warning"
      isOpen={unconfirmationModalVisible}
      handleClose={onCloseUnconfirmation}
      title="Unconfirm Step?"
      message="Are you sure you want to unconfirm this step? This will revert the step back to a non-confirmed state."
      footerActions={{
        primary: {
          text: 'Unconfirm',
          onClick: onUnconfirmContinue,
          isLoading: isConfirming
        }
      }}
    />
  </>
);

export default AccordionConfirmModals;
